import { Receipt, Percent, CreditCard } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export const InvoiceTotals = ({ subtotal, tax, taxRate, total }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(amount);
  };

  return (
    <div className="flex justify-end">
      <div className="w-full max-w-sm space-y-3">
        {/* Subtotal */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Receipt className="w-4 h-4" />
            <span>Subtotal</span>
          </div>
          <span className="font-medium text-foreground">
            {formatCurrency(subtotal)}
          </span>
        </div>

        {/* Tax */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Percent className="w-4 h-4" />
            <span>HST ({(taxRate * 100).toFixed(0)}%)</span>
          </div>
          <span className="font-medium text-foreground">
            {formatCurrency(tax)}
          </span>
        </div>

        <Separator className="my-3" />

        {/* Grand Total */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-foreground">
            <CreditCard className="w-5 h-5 text-primary" />
            <span className="text-base font-semibold">Grand Total</span>
          </div>
          <span className="text-xl font-bold text-primary">
            {formatCurrency(total)}
          </span>
        </div>

        {/* Payment Instructions */}
        <div className="mt-4 p-4 bg-primary/5 border border-primary/10 rounded-lg">
          <p className="text-xs text-muted-foreground leading-relaxed">
            Payment is due within 30 days. Please include invoice number on your payment.
            Accepted methods: Credit Card, Bank Transfer, Cheque.
          </p>
        </div>
      </div>
    </div>
  );
};
